import apiHandler from "../core/apiHandler";

const contingencyEventApi = apiHandler('dte/contingencies');
export default contingencyEventApi;
